import { createTheme, ThemeProvider } from "@mui/material/styles";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import "./shared_modules/ui/styles/globals.css";

const theme = createTheme({
  palette: {
    primary: {
      light: "#fcac04",
      main: "#fcac04",
      dark: "#fcac04",
      contrastText: "white",
    },
    secondary: {
      light: "#bdbdbd",
      main: "#bdbdbd",
      dark: "#bdbdbd",
      contrastText: "white",
    },
  },
  typography: {
    fontFamily: ["Plus Jakarta Sans", "sans-serif"].join(","),
    //fontSize: [14, "!important"]
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
